import React, { FC } from "react";
import rightImgPng from "images/logos/tribyou_logo.png";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";
import feature1 from "images/tribyou_decorations/liberta.png";
import feature2 from "images/tribyou_decorations/sicurezza.png";
import feature3 from "images/tribyou_decorations/tribu.png";
import { useTranslation } from "react-i18next";
import { TwMainColor } from "data/types";

export interface SectionOurFeaturesProps {
  className?: string;
  rightImg?: string;
  type?: "type1" | "type2";
}

const SectionOurFeatures: FC<SectionOurFeaturesProps> = ({
  className = "lg:py-14",
  rightImg = rightImgPng,
  type = "type1",
}) => {

  const [selected, setSelected] = React.useState(0);
  const { t, ready } = useTranslation("translation");

  if (!ready) return null;

  const benefitsList = t('translation:home.benefits.list', {returnObjects: true}) as any[];
  const badgeColors: TwMainColor[] = ["yellow", "blue", "green"];

  const returnImage = () => {
    switch (selected) {
      case 0:
        return feature1;
      case 1:
        return feature3;
      case 2:
        return feature2;
      default: 
        return feature1;
    }
  }


  return (
    <div
      className={`nc-SectionOurFeatures relative flex flex-col-reverse items-center ${type === "type1" ? "lg:flex-row" : "lg:flex-row-reverse"
        } ${className}`}
      data-nc-id="SectionOurFeatures"
    >
      <div className="flex-grow">
        <NcImage src={returnImage()} className="w-full" />
      </div>
      <div
        className={`max-w-3xl flex-shrink-0 mt-10 lg:mt-0 lg:w-2/4 ${type === "type1" ? "lg:pl-14" : "lg:pr-16"
          }`}
      >
        <span className="uppercase text-sm text-gray-400 tracking-widest pl-4">
          {t("translation:home.benefits.sectionName")}
        </span>
        <h2 className="font-semibold text-4xl mt-5 pl-4">{t("translation:home.benefits.title")}</h2>

        <ul className="lg:mt-16 mt-8">
          {
            benefitsList.map((item: any, index: number) => {
              return (
                <li key={`benefit-${index}`} className="space-y-4 hover:bg-neutral-100 rounded-lg p-4 cursor-pointer" onMouseEnter={() => setSelected(0)}>
                  <Badge color={badgeColors[index]} name={item.badge} />
                  <span className="block text-xl font-semibold">
                    {item.title}
                  </span>
                  <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
                    {item.description}
                  </span>
                </li>
              )
            }
          )}
        </ul>
      </div>
    </div>
  );
};

export default SectionOurFeatures;
